const EstadosDeCliente = {
    HAB: "Habilitado",
    DHAB: "En Baja",
};

export { EstadosDeCliente}